import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import 'data/i18next';

import { App, Auth, Lang, Preloader, Query, Theme } from 'context';
import { OfflineNotification } from 'components/layout';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <Lang.Provider>
    <Theme.Provider>
      <Preloader.Provider>
        <Query.Provider>
          <Auth.Provider>
            <App.Provider />
          </Auth.Provider>
        </Query.Provider>
        <OfflineNotification />
      </Preloader.Provider>
    </Theme.Provider>
  </Lang.Provider>,
);
